import React, { Component } from 'react';
import Trigger from 'choerodon-ui/lib/trigger';
import DropdownMenu from './DropdownMenu';
import BUILT_IN_PLACEMENTS from '../trigger-field/placements';
class KeywordTrigger extends Component {
    getDropdownElement() {
        const { options } = this.props;
        return React.createElement(DropdownMenu, { options: options });
    }
    getDropDownPlacement() {
        const { placement } = this.props;
        const popupPlacement = placement === 'top' ? 'topLeft' : 'bottomLeft';
        return popupPlacement;
    }
    render() {
        const { children, visible, getPopupContainer, prefixCls } = this.props;
        const popupElement = this.getDropdownElement();
        return (React.createElement(Trigger, { prefixCls: prefixCls, popupHidden: !visible, popupContent: popupElement, popupPlacement: this.getDropDownPlacement(), builtinPlacements: BUILT_IN_PLACEMENTS, getPopupContainer: getPopupContainer }, children));
    }
}
export default KeywordTrigger;
